import angular from 'angular'

export class DynamicComponentDirective {
 static selector = 'dynamicComponent'
 static templateService($compile) {
  //Usage: <element dynamic-component='componentSelector'></element>
  var directive = {
   restrict: 'A',
   transclude: true,
   replace: true,
   link: link,
  }

  return directive

  function link(scope, element, attrs) {
   scope.$watch(attrs.dynamicComponent, function(newValue, oldValue) {
    element.html(`<${newValue}
                    trigger-update="$ctrl.onUpdate"
                    viz-data="$ctrl.vizData"
                    vis-title="$ctrl.properties.title"
                    visualization-id="$ctrl.visualizationId"
                    size="$ctrl.properties.size"
                    is-loading="$ctrl.isLoading"
                    is-error="$ctrl.isError"
                    csv-export-profiles="$ctrl.csvExportProfiles"
                    pagination="$ctrl.pagination"
                    properties="$ctrl.properties"
                    date-range="$ctrl.dateRange"
                    options="$ctrl.properties"
                    is-restricted="$ctrl.isRestricted"
                    location-type="$ctrl.locationType"
                    visualization-meta-data="$ctrl.visualizationMetaData">
                    </${newValue}>
                `)
    $compile(element.contents())(scope)
   })
  }
 }
}
